import React from 'react'

const ModalHeading = ({ title }: { title: string }) => {
  return <div className="modalHeading">{title}</div>
}

export default ModalHeading
